export enum IntegrationWizardSteps {
  AppAttributes,
  HierarchyElementTypes,
  NetworkElementTypes,
  NetworkElementSubTypes,
  CustomerClassTypes,
  BillingClasses,
  MaterialTypes,
  ActivityTypes,
  SapCodeGroups,
  SapCodes,
  SapLeakCodes,
  LeakTypeGroups,
  LeakTypes,
  FamiliesAndRelations,
  GisLayers,
  NetworkElementAttributeTypes,
  NetNeatLink,
  GisLayerKpi,
}
